import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from "@angular/core";
import { RespectRedirectsService } from "./response/respect-redirects.service";
import { RespectSessionNoticesService } from "./response/respect-session-notices.service";

export function provideDfApi(): EnvironmentProviders {
    return makeEnvironmentProviders([
        provideAppInitializer(() => {
            inject(RespectRedirectsService).appInitialize();
            inject(RespectSessionNoticesService).appInitialize();
        })
    ]);
}